import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import white_logo from '../assets/images/white_logo.png';

const Footer = () => {
  const [popularCities, setPopularCities] = useState([]);

  useEffect(() => {
    fetch('https://dayoffice24.it/api/popular-cities')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.success) {
          setPopularCities(data.data);
        } else {
          throw new Error('API returned an error:' + data.message);
        }
      })
      .catch((error) => {
        console.error('Error fetching popular cities:', error);
      });
  }, []);

  // Check if popularCities data is available
  if (popularCities.length === 0) {
    return <p>Loading...</p>; // Show a loading message while data is being fetched
  }


  return (    
      <footer className="footer-wrap style2 blck_footer pt-100">
            <div className="footer-top">
               <div className="container">
                  <div className="row pb-75">
                     <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 pe-xl-5">
                        <div className="footer-widget">
                              <img className="logo-light" src={white_logo} alt="Image" />
                           <p className="comp-desc">
                              DayOffice24 si trova in una delle più celebri piazze romane situato in uno dei quattro palazzi storici della zona. Piazza Bologna è un punto d’incontro tra studenti universitari e uffici e aziende di diversa natura. 
                           </p>
                        </div>
                     </div>
                     <div className="col-xl-2 col-lg-6 col-md-6 col-sm-6">
                        <div className="footer-widget">
                           <h3 className="footer-widget-title">Popular Cities</h3>
                            <ul className="footer-menu list-style">
                              {popularCities.map((city) => (
                                <li key={city._id}>
                                  <a href={`/Cities/${city._id}`}>
                                    <i className="ri-arrow-right-s-line"></i>
                                    {city.city_name}
                                  </a>
                                </li>
                              ))}
                            </ul>
                        </div>
                     </div>
                     <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 ps-xl-5">
                        <div className="footer-widget">
                           <h3 className="footer-widget-title">Quick Links</h3>
                           <ul className="footer-menu list-style">
                              <li>
                                 <a href="/About">
                                 <i className="ri-arrow-right-s-line"></i>
                                 About Us
                                 </a>
                              </li>
                              <li>
                                 <a href="/HelpCenter">
                                 <i className="ri-arrow-right-s-line"></i>
                                 Help Center
                                 </a>
                              </li>
                              <li>
                                 <a href="/Faq">
                                 <i className="ri-arrow-right-s-line"></i>
                                 Faq
                                 </a>
                              </li>
                              <li>
                                 <a href="/Privacy">
                                 <i className="ri-arrow-right-s-line"></i>
                                 Privacy Policy
                                 </a>
                              </li>
                              <li>
                                 <a href="/Terms">
                                 <i className="ri-arrow-right-s-line"></i>
                                 Terms & Conditions
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                     <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                        <div className="footer-widget">
                            <h3 className="footer-widget-title">Social</h3>
                           <ul className="social-profile list-style style1">
                               <li>
                                  <a target="_blank" href="https://facebook.com">
                                  <i className="ri-facebook-fill"></i>
                                  </a>
                               </li>
                               <li>
                                  <a target="_blank" href="https://twitter.com">
                                  <i className="ri-twitter-fill"></i>
                                  </a>
                               </li>
                               <li>
                                  <a target="_blank" href="https://instagram.com">
                                  <i className="ri-instagram-line"></i>
                                  </a>
                               </li>
                               <li>
                                  <a target="_blank" href="https://linkedin.com">
                                  <i className="ri-linkedin-fill"></i>
                                  </a>
                               </li>
                            </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div className="container">
               <div className="footer-bottom">
                  <div className="row align-items-center">
                     <div className="col-md-12">
                        <p className="copyright-text">
                           <i className="ri-copyright-line"></i>HRD Group Srl S. &copy 2023. All Rights Reserved.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </footer>

  );
};

export default Footer;
